import { createSlice } from "@reduxjs/toolkit";
import { exportAiCampaignResultsAPI } from "../../services/exportAiCampaignResults";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const exportAiCampaignResultsSlice = createSlice({
  name: "exportAiCampaignResults",
  initialState: data,
  reducers: {
    exportAiCampaignResultsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    exportAiCampaignResultsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message =
        action.payload?.message || "Campaign results exported successfully";
      state.error = "";
    },
    exportAiCampaignResultsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    exportAiCampaignResultsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const exportAiCampaignResultsHandler = (payload) => async (dispatch) => {
  try {
    dispatch(exportAiCampaignResultsAction.exportAiCampaignResultsInfo());
    const response = await exportAiCampaignResultsAPI(payload);
    dispatch(
      exportAiCampaignResultsAction.exportAiCampaignResultsInfoSuccess(response)
    );
  } catch (e) {
    dispatch(
      exportAiCampaignResultsAction.exportAiCampaignResultsInfoFailure(
        e?.response?.data?.message || e?.message || e
      )
    );
  }
};

export default exportAiCampaignResultsSlice.reducer;
export const exportAiCampaignResultsAction =
  exportAiCampaignResultsSlice.actions;
